<div class="number-input-container" [ngClass]="[containerCss, classList]">
  <ng-container *ngIf="!labelInside" [ngTemplateOutlet]="labelTemplate"></ng-container>

  <div class="number-input-field">
    <div class="input-container">
      <span *ngIf="labelInside && label" class="inline-label">{{ label }}</span>
      <div class="value-group">
        <span *ngIf="prefix" class="number-prefix" [ngClass]="{ 'small-font': isSmallFont }">
          {{ prefix }}
        </span>

        <input
          matInput
          type="text"
          aria-label="number-input"
          [formControl]="innerControl"
          [placeholder]="attrPlaceholder"
          (paste)="onPaste($event, inputEl)"
          [mask]="attrMask"
          [thousandSeparator]="attrThousandSeparator"
          [validation]="true"
          [allowNegativeNumbers]="true"
          [maxlength]="max"
          #inputEl />

        <span *ngIf="postfix" class="number-postfix" [ngClass]="{ 'small-font': isSmallFont }">
          {{ postfix }}
        </span>
      </div>
    </div>
  </div>
</div>

<ng-template #labelTemplate>
  <div class="label-container" *ngIf="label || icon">
    <label
      *ngIf="label"
      class="dropdown-label"
      [ngClass]="[
        labelCss,
        labelInside ? 'inside' : '',
        innerControl.disabled ? 'disable' : '',
        labelRequired ? 'label-required' : ''
      ]"
      [matTooltip]="labelTooltip">
      {{ label }}
    </label>

    <app-icon *ngIf="icon" [svg]="icon" [iconHeight]="24" [iconWidth]="24" [matTooltip]="iconTooltip"></app-icon>
  </div>
</ng-template>
